/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".left[_ngcontent-%COMP%] + .left[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
